import axios from 'axios';
import { LoginPageUrl } from '../url/poenUrl';

/**
 * 📌 baseURL 설정
 * - localhost, IP 주소, admin 도메인 구분
 */
const baseURL: string = (() => {
  const hostname = window.location.hostname.replace('admin.', ''); // admin 제거
  if (['localhost', '127.0.0.1'].includes(hostname))
    return 'http://172.27.0.31:12021/';
  return `${window.location.protocol}//${hostname}${window.location.port ? ':' + window.location.port : ''}/`;
})();

//console.log('baseURL', baseURL);

// Axios 인스턴스 생성
const apiClient = axios.create({
  baseURL,
  withCredentials: true,
});

/**
 * 📌 Helper 함수
 * 401 및 403 에러 핸들링
 */
const handleUnauthorizedResponse = (status: number, data: string) => {
  const permissions = localStorage.getItem('permissions'); // authority 추가

  const errorMessage =
    status === 401
      ? data
      : permissions
        ? `${permissions} 권한이 만료되었습니다. 다시 로그인 해주세요.`
        : '권한이 만료되었습니다. 로그인 먼저 해주세요.';

  // 공통 데이터 제거
  localStorage.clear();
  sessionStorage.clear();

  // 쿠키 리셋
  document.cookie.split(';').forEach((cookie) => {
    const [name] = cookie.split('=');
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  });
  window.location.href = LoginPageUrl; // 사용자 로그인 페이지로 리다이렉트

  return Promise.reject(new Error(errorMessage));
};

// 요청 인터셉터 설정
apiClient.interceptors.request.use(
  (config) => {
    const useToken = config.headers['useToken'] !== false;
    if (useToken) {
      const token = localStorage.getItem('accessToken');
      if (token) config.headers.Authorization = `Bearer ${token}`;
    }
    delete config.headers['useToken']; // useToken 제거
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => {
    if (response.config.responseType === 'blob') {
      return response;
    }

    return {
      ...response,
    };
  },
  (error) => {
    const { response } = error;

    // 401, 403 에러 핸들링
    if (response && [401, 403].includes(response.status)) {
      return handleUnauthorizedResponse(response.status, response.data.data);
    }

    // 오류 메시지를 서버에서 제공하는 메시지로 설정
    const message =
      `${response?.status || '알 수 없는 오류'}: ${response?.data?.data}` ||
      `${response?.status || '알 수 없는 오류'}: 요청이 실패했습니다.`;
    return Promise.reject(new Error(message));
  }
);

export default apiClient;
